module.exports = __webpack_public_path__ + "static/media/task-modal-success@2x.86ddca80.png";